<template>
  <div class="orderTaiwanTravel">
    <div class="payment__block">
      <div class="payment__block-head">
        <div class="flex flex-col" :class="this['user/isLogin'] ? 'rule' : 'rule-notLogin'">
          <h4 class="title">{{ $t('taiwanTravel.title') }}</h4>
          <p v-if="!isMobile" class="text-sm font-bold mt-4">
            {{ this['order/taiwanTravelCanUseNum'] > 0 ? $t('taiwanTravel.howManyCanUse', { 'num': this['order/taiwanTravelCanUseNum'] }) : $t('taiwanTravel.cantUse') }}
            <span class="text-blue-light cursor-pointer" @click="showTravelRule">{{ $t('taiwanTravel.rule') }}</span>
          </p>
        </div>
        <div class="payment__switcher">
          <img v-if="!isMobile" class="mr-16" :src="imgUrl" :alt="$t('taiwanTravel.title')">
          <label v-if="this['user/isLogin']" class="owl-switch__wrap">
            <input type="checkbox" v-model="selectTaiwanTravel" @change="toggleSelectTaiwanTravel" :disabled="this['order/taiwanTravelCanUseNum'] <= 0">
            <div class="owl-switch__item">
              <div class="owl-switch__bg" :class="this['order/taiwanTravelCanUseNum'] <= 0 ? 'disabled' : ''">
                <div class="owl-switch__button"></div>
              </div>
            </div>
          </label>
          <div v-else class="flex flex-col md:flex-row justify-between md:items-center">
            <button v-if="!isMobile" class="btn btn-sm px-16 btn-solid btn-blue-light" @click="this['user/goLogin']">{{ $t('taiwanTravel.becomeMemberToUse') }}</button>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="mt-24">
        <img :src="imgUrl" :alt="$t('taiwanTravel.title')">
        <p class="text-sm font-bold mt-8">
          {{ this['order/taiwanTravelCanUseNum'] > 0 ? $t('taiwanTravel.howManyCanUse', { 'num': this['order/taiwanTravelCanUseNum'] }) : $t('taiwanTravel.cantUse') }}
          <span class="text-blue-light cursor-pointer" @click="showTravelRule">{{ $t('taiwanTravel.rule') }}</span>
        </p>
        <button v-if="!this['user/isLogin']" class="w-full btn btn-sm px-16 btn-solid btn-blue-light mt-16" @click="this['user/goLogin']">{{ $t('taiwanTravel.becomeMemberToUse') }}</button>
      </div>
      <div class="form__form form-switched" :class="selectTaiwanTravel ? 'show' : ''">
        <div class="form__form w-full xl:w-2/3">
          <div class="form__form-full form__form-travel" v-for="(obj, o_index) in travalArray" :key="`travalArray_${o_index}`">
            <div class="flex flex-wrap">
              <div v-if="o_index > 0 && isMobile" class="w-full text-right">
                <button @click="removeTravelCode(o_index)">
                  <i class="owl owl-status-error text-grey" />
                </button>
              </div>
              <div class="form__form-half">
                <label class="font-bold" for="voucherCode">{{ $t('taiwanTravel.voucherCode') }}</label>
                <input type="text" v-model="obj.voucherCode" class="form__content input w-full" :class="{ 'fail': obj.status === 'WRONG', 'success': obj.status === 'OK' }" name="voucherCode" maxlength="12" :placeholder="$t('taiwanTravel.required')">
              </div>
              <div class="form__form-quarter mt-32 sm:mt-0">
                <label class="font-bold" for="idLastFour">{{ $t('taiwanTravel.idLastFour') }}</label>
                <input type="text" v-model="obj.idLastFour" class="form__content input w-full" :class="{ 'fail': obj.status === 'WRONG', 'success': obj.status === 'OK' }" name="idLastFour" maxlength="4" :placeholder="$t('taiwanTravel.required')">
              </div>
              <div class="self-center mt-24 ml-16" v-if="o_index > 0 && !isMobile">
                <button class="block" @click="removeTravelCode(o_index)">
                  <i class="owl owl-status-error text-grey" />
                </button>
              </div>
            </div>
            <div v-if="obj.status !== ''" class="verifyMsg" :class="obj.status === 'WRONG' ? 'verifyFail' : 'verifySuccess'">{{ obj.status === 'WRONG' ? $t('taiwanTravel.verifyResult.fail') : $t('taiwanTravel.verifyResult.success') }}</div>
          </div>

          <div v-if="timeout" class="text-sm my-16">
            <i class="owl owl-status-triangle-warning text-orange text-base" /> {{ $t('taiwanTravel.verifyResult.timeout') }}
          </div>
          <div class="flex">
            <button class="btn btn-ghost btn-grey" @click="addTravelCode" :disabled="travalArray.length >= this['order/taiwanTravelCanUseNum']">{{ $t('taiwanTravel.addTravel') }}</button>
            <button class="btn btn-solid btn-green-dark ml-8" @click="checkTaiwanTravel" :disabled="isCheckingCode || !canCheck" v-loading="isCheckingCode" element-loading-spinner="owl-arrow-reload animate-spin">{{ $t('taiwanTravel.verify') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fullPageModal from '@/components/modals/fullPageModal'
import taiwanTravelPolicy from '@/components/taiwanTravelPolicy'
import taiwanTravelImageUrl from '@/assets/images/taiwanTravel.png'
import { mapActions, mapMutations, mapGetters } from 'vuex'

const travalObj = {
  voucherCode: '',
  idLastFour: '',
  status: ''
}
export default {
  name: 'OrderTaiwanTravel',
  data () {
    return {
      imgUrl: taiwanTravelImageUrl,
      travalArray: [],
      isCheckingCode: false,
      timeout: false
    }
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'user/isPremium',
      'order/order',
      'order/isUsingTaiwanTravel',
      'order/taiwanTravelCodeList',
      'order/selectedCoupon',
      'order/taiwanTravelCanUseNum',
      'user/isLogin'
    ]),
    selectTaiwanTravel: {
      get () {
        return this['order/isUsingTaiwanTravel']
      },
      set () {
        return this['order/SET_TAIWAN_TRAVEL']
      }
    },
    canCheck () {
      return this.travalArray.every(e => {
        return (e.voucherCode && e.idLastFour)
      })
    }
  },
  methods: {
    ...mapActions([
      'order/checkTaiwanTravelCoupon',
      'order/onSaveDiscount',
      'order/setCouponToUpdate',
      'user/goLogin'
    ]),
    ...mapMutations([
      'order/SET_TAIWAN_TRAVEL',
      'order/SET_TAIWAN_TRAVEL_CODE_LIST',
      'order/RESET_TAIWAN_TRAVEL_CODE_LIST',
      'order/RESET_DISCOUNT_SWITCH',
      'order/CLEAR_COUPON'
    ]),
    toggleSelectTaiwanTravel () {
      this['order/SET_TAIWAN_TRAVEL'](!this.selectTaiwanTravel)
      // 可清可不清，不清如果他又開起來就不用重新填寫(如果有填)
      if (this.selectTaiwanTravel) {
        this.travalArray = []
        this.travalArray.push({ ...travalObj })
        // if (!this['user/isPremium']) { // 鑽石會強迫一定要用，所以非鑽石的再清
        //   this['order/RESET_DISCOUNT_SWITCH']()
        //   this['order/CLEAR_COUPON']()
        // }
      }
      if (!this.selectTaiwanTravel) {
        this['order/RESET_TAIWAN_TRAVEL_CODE_LIST']()
        this['order/RESET_DISCOUNT_SWITCH']()
        this['order/CLEAR_COUPON']()
      }
    },
    addTravelCode () {
      this.travalArray.push({ ...travalObj })
    },
    removeTravelCode (index) {
      this.travalArray.splice(index, 1)
    },
    showTravelRule () {
      this.$modal.show(fullPageModal, {
        // 輸入內容
        context: taiwanTravelPolicy
      },
      {
        adaptive: true,
        name: 'TravelPolicy',
        // clickToClose: false,
        // height: '95%',
        height: 'auto',
        width: '95%',
        maxWidth: 812,
        scrollable: true
      })
    },
    checkTaiwanTravel () {
      if (this.selectTaiwanTravel) {
        this.timeout = false
        this['order/SET_TAIWAN_TRAVEL_CODE_LIST'](this.travalArray)
        this.isCheckingCode = true
        this['order/checkTaiwanTravelCoupon']({
          orderSerial: this['order/order'].orderSerial
        }).then(res => {
          this.isCheckingCode = false
          if (res.status === 200) {
            if (res.data.coupon) {
              this['order/onSaveDiscount'](res.data.coupon)
              this['order/setCouponToUpdate']()
            }
          } else {
            if (res.status === 10000) this.timeout = true
          }
        })
      }
    }
  },
  mounted () {
    this.validation.reset()
  },
  created () {
  },
  beforeDestroy () {
    // destroy 前將資料初始化
    this['order/SET_TAIWAN_TRAVEL'](false)
    this['order/RESET_TAIWAN_TRAVEL_CODE_LIST']()
  }
}
</script>
<style lang="sass" scoped>
  .orderTaiwanTravel
    @apply border border-grey-lighter rounded
    @apply mb-24
    .payment__block
      @apply p-16
      & + &
        @apply border-t-1 border-grey-lighter
      &-head
        @apply flex justify-between items-center
        .rule
          max-width: calc(100% - 250px)
        .rule-notLogin
          max-width: calc(100% - 350px)
        .title
          @apply font-bold
        .payment__switcher
          @apply flex
          &-radio
            & + &
              @apply mt-16
              @screen sm
                @apply mt-0 ml-32
          .owl-switch__bg
            &.disabled
              @apply bg-grey-light cursor-not-allowed
      .form__form
        @apply mt-24
        &.form-switched
          @apply overflow-hidden
          @apply opacity-0
          @apply mt-0
          height: 0
          transition: opacity 0.3s ease
        &.show
          @apply opacity-100
          @apply h-full
      .form__form-quarter
        @apply w-full
        .success
          @apply bg-green-lightest border-green-darker
        .fail
          @apply bg-red-lightest border-red-dark
        @screen sm
          @apply pr-8 pl-0 w-1/3
          & + &
            @apply pr-0 pl-8
      .form__form-half
        @apply w-full flex flex-col justify-between
        .success
          @apply bg-green-lightest border-green-darker
        .fail
          @apply bg-red-lightest border-red-dark
        @screen sm
          @apply pr-8 pl-0 w-1/2
          & + &
            @apply pr-0 pl-8
      .form__form-full
        @apply w-full
        &:not(:first-child)
          @apply mt-16
        & + &
          @apply mt-32
      .form__form-travel
        @apply border border-grey-lighter rounded relative
        @apply p-16 mb-24
        & + &
          @apply mt-16
        .verifyMsg
          @apply text-xs mt-4 font-semibold
        .verifySuccess
          @apply text-green-darker
        .verifyFail
          @apply text-red-dark
      .form__content
        @apply text-sm leading-normal
        @apply mt-8
</style>
